export const froalaKey = function getFroalaKey() {
  if ("false" == "true" || "false" == "true") {
    return null
  } else {
    return "HQD1uA7B2B1C1B1B1lI-8kA2rgE-13rvB-8isumxprbgH3kwaD-17D2E2F2H2E4G1A2B8D7E7=="
  }
}
